import { EnumsInterface } from "@/interfaces/EnumsInterface";

const LegalStatus:EnumsInterface[] = [
    {id: 0, value: 0, label: "Adopted"},
    {id: 1, value: 1, label: "Legitimate"},
    {id: 2, value: 2, label: "Illegitimate"},
    {id: 3, value: 3, label: "Unknown"},
]

export default LegalStatus